<template>
  <div class="booking-confirmation-main">
    <ReportsHomeV2 :disableFilter="true" :infoSections="[ 'Header', 'Footer' ]" title="Booking Confirmation Letter" placeholder="Job No"
      :inputValue.sync="jobno" @generateReport="generateReport" @shareReport="shareReport" ref="mainReport" :sections="reportSection">
      <div slot="Document / Notice / Letter Info_Header">
        <DateTimePicker placeholder="Date" :value="jobData['date']" />
        <div class="inline-row">
          <Input placeholder="To" :inputValue.sync="jobData['To']" />
          <Input style="margin-left: 5px" placeholder="Attn" :inputValue.sync="jobData['Attn']" />
        </div>
        <div class="inline-row">
          <Input placeholder="Tel" :inputValue.sync="jobData['Tel']" />
          <Input style="margin-left: 5px" placeholder="Fax" :inputValue.sync="jobData['Fax']" />
        </div>
        <CheckBox title="Show company letter head" :isChecked.sync="jobData['showLetterHead']" />
      </div>

      <div slot="Document / Notice / Letter Info_Footer">
        <div class="remarks">
          <Dropdown style="width:30%; margin-bottom:-20px;"  placeholder="Remarks List" :items="remarksList" itemKey="RemarksCode" :selectedObject.sync="selectedRemarks" @selected="changeRemarks" />
          <RemarksBox style="height: 120px; width: 100%" title="" :freeText="true" :text.sync="jobData['Remarks']" :maxLength="500" />
        </div>
        <div class="inline-row">
          <RemarksBox title="Regards" style="height: 200px; margin-right: 5px" :freeText="true" :text.sync="jobData['Regards']" />
          <div class="booking-signature-form">
            Signature
            <button @click="editSignature = !editSignature">{{ editSignature ? 'Back' : 'Edit' }}</button>
            <div class="booking-details-remarks">
              <div v-if="!editSignature" style="height: 100%; width: 100%;">
                <div v-if="!selectedSignature">No signature selected</div>
                <img v-else :src="selectedSignature" class="selected-signature">
              </div>
              <div v-else class="signature-another">
                <div v-if="allSignature.length == 0">No available signature</div>
                <div v-else class="choose-signature">
                  Choose another signature
                  <div v-if="selectedSignature" class="default-signature" style="margin-top: 5px; margin-bottom: 40px">
                    <button @click="defaultSignatureSelect()" style="background-color: red; color: white">Clear Selected Signature</button>
                  </div>
                  <div class="default-signature" v-for="(s, i) in allSignature" :key="i">
                    Signature {{ i + 1 }}<button @click="defaultSignatureSelect(i)">Select</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="Doc info 2_Header">
        <div>Yes working!</div>
      </div>
    </ReportsHomeV2>

    <Loader :isVisible.sync="loading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :type="popupType" :show="showPopup" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false"></PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      loading: false,
      loadingText: '',
      jobno: '',

      reportSection: [
        {
          name: 'Document / Notice / Letter Info',
          child: [ 'Header', 'Footer', ],
          show: true
        },
        // { // Not using at the moment
        //   name: 'Job Filtering',
        //   child: [],
        //   show: false
        // }
      ],

      editSignature: false,
      allSignature: [],
      selectedSignature: null,

      showPopup: false,
      popupType: 'info',
      popupTitle: '',
      popupContent: '',

      jobData: {},

      remarksList: [],
      selectedRemarks: {}
    }
  },
  props: {
  },
  methods: {
    getSignatureDetails: async function () {
      this.allSignature = [];
      let userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
      if (userOptionsData.length > 0) {
        if (userOptionsData[0]['SettingsValue']) {
          let userOptionsObj = JSON.parse(userOptionsData[0]['SettingsValue']);
          if (userOptionsObj['Signature1']) { this.allSignature.push(userOptionsObj['Signature1']) }
          if (userOptionsObj['Signature2']) { this.allSignature.push(userOptionsObj['Signature2']) }
          if (userOptionsObj['Signature3']) { this.allSignature.push(userOptionsObj['Signature3']) }
        }
      }
    },
    defaultSignatureSelect: function(index) {
      if (index >= 0) {
        this.selectedSignature = this.allSignature[index];
      } else {
        this.selectedSignature = null;
      }

      this.editSignature = false;
    },
    getFormDetails: async function() {
      let loginDetails = await this.$apiCallV2('/Login/GetDetails');
      // let jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&jobno=${this.jobno}`);
      let jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?jobno=${this.jobno}`);
      if (jsDetails.length == 0) {
        this.showPopup = true;
        this.popupTitle = 'Invalid Job No';
        this.popupContent = `Job No '${this.jobno}' is invalid. Please enter a valid Job No`;
      } else {
        this.jobData = jsDetails['JobDetails']['Job'];
        this.jobData['date'] = new Date();
        console.log(jsDetails.JobDetails.Job['Remarks']);
        console.log(this.jobData['Remarks']);
        this.jobData['To'] = jsDetails.JobDetails.Job['Shipper Name'];
        this.jobData['Attn'] = jsDetails.JobDetails.Job['Cust Attn'];
        this.jobData['Tel'] = jsDetails.JobDetails.Job['Cust Tel'];
        this.jobData['Fax'] = jsDetails.JobDetails.Job['Cust Fax'];
        this.jobData['Remarks'] = !this.jobData['Remarks'] ? '' : jsDetails.JobDetails.Job['Remarks'];
        //this.jobData['Remarks'] = '';
        this.jobData['Regards'] = loginDetails.UserName;
        
        this.jobData['showLetterHead'] = true;
      }

      let remarkslistjson = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FORWARDING_AGENT' });
      // console.log(remarkslist);
      //(forwardingAgent[0]['addinfojson'])['LOIRPT']['FORWARDING_AGENT']
      // this.remarksList = JSON.parse(remarkslistjson[0]['addinfojson']);
      this.remarksList = JSON.parse(remarkslistjson[0]['addinfojson'])['BookingConfirmationLetter']?.['Remarks'];
    },

    generateReport: async function() {
      this.loading = true;
      this.loadingText = 'Generating Report';

      this.jobData['companyHeader'] = this.jobData['showLetterHead'] ? (await this.$apiCallV2('/Login/GetDetails'))['CoHeaderOpr'] : 'https://www.publicdomainpictures.net/pictures/30000/velka/plain-white-background.jpg';
      //console.log(this.jobData['companyHeader']);
      this.jobData['BCDate'] = this.$dateTime.getDateTime(this.jobData['date'], 'dd-MM-yyyy');
      this.jobData['Signature'] = this.selectedSignature;

      //console.log(this.jobData['inputRemarks']);
      this.jobData['inputRemarks'] = this.jobData.Remarks.replace(/\n/g, "</br>");
      await this.$refs['mainReport'].generateReport('j7o6kc7VmL', this.jobData);

      this.loading = false;
    },
    shareReport: async function() {
      this.loading = true;
      this.loadingText = 'Generating Link';

      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      let fileName = `${loginDetails['ConfigCode']}_${loginDetails['LoginUserId']}_BCL_${this.jobno}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`.split('/').join('_');
      await this.$refs['mainReport'].generateShareLink(fileName, loginDetails['ConfigCode'], {
        subject: `${this.jobData['Job No'] ? this.jobData['Job No'].trim() : ''} - ${this.jobData['Job Type'] == 'I' ? (this.jobData['BL No'] ? this.jobData['BL No'].trim() : '') : (this.jobData['Booking Ref No'] ? this.jobData['Booking Ref No'].trim() : '')} - Booking Confirmation`,
        body: `Your Reference No.: ${this.jobData['Cust Ref No'] ? this.jobData['Cust Ref No'].trim() : ''}\n\nClick on the link below to view the Booking Confirmation:\n{link}`
      });

      this.loading = false;
    },

    changeRemarks: function(val) {
      this.jobData['Remarks'] = val ? val['Remarks'] : '';
    }
  },
  async mounted() {
    let jobNo = this.$route.query['jobno'];
    if (jobNo) {
      this.jobno = jobNo;
      this.loadingText = "Getting Booking Details"
      this.loading  = true;

      await this.getSignatureDetails();
      await this.getFormDetails();

      this.loading = false;

      await this.generateReport();
    }
  },
  watch: {
    // selectedRemarks(val) {
    //   this.jobData['Remarks'] = val['Remarks'];
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.booking-confirmation-main {
  height: 100%;
  width: 100%;
}

.remarks {
  display: flex;
  flex-direction: column;
}

.inline-row {
  display: flex;
}

.booking-signature-form {
  width: 100%;
  margin-top: 3px;

  > button {
    padding: 0 15px;
    float: right;
  }
  
  > .booking-details-remarks {
    border: 1px solid rgb(200,200,200);
    border-radius: 3px;
    width: 100%;
    height: calc(100% - 21px);
    overflow: auto;
    max-height: 185px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 5px;
    padding-right: 5px;

    > .signature-another {
      width: 100%;

      > .choose-signature {
        > .default-signature {
          margin-top: 8px;
  
          > button {
            float: right;
            padding: 2px 5px;
          }
        }
      }
    }
  }
}

.selected-signature {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>